import isEqual from 'lodash/isEqual';
import {BuildingNodeState} from '../../../../../../submodules/map/mapiq-map/MapState';

export const buildingNodeStatesAreEqual = (
  bns1: ReadonlyMap<string, BuildingNodeState>,
  bns2: ReadonlyMap<string, BuildingNodeState>,
) => {
  return isEqual(bns1, bns2);
};
